var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
function removeUndefinedKeys(object) {
    Object.keys(object).forEach(key => (object[key] === undefined ? delete object[key] : ''));
}
const extractClassNameProps = props => {
    const { className } = props, restProps = __rest(props, ["className"]);
    const classNameProps = { className };
    removeUndefinedKeys(classNameProps);
    return {
        classNameProps,
        restProps
    };
};
const extractWidthProps = props => {
    const { width } = props, restProps = __rest(props, ["width"]);
    const widthProps = { width };
    removeUndefinedKeys(widthProps);
    return {
        widthProps,
        restProps
    };
};
const extractHeightProps = props => {
    const { height } = props, restProps = __rest(props, ["height"]);
    const heightProps = { height };
    removeUndefinedKeys(heightProps);
    return {
        heightProps,
        restProps
    };
};
const extractWrapperMarginProps = props => {
    const { m, margin, marginTop, marginRight, marginBottom, marginLeft, mt, mr, mb, ml, mx, my, marginX, marginY } = props, restProps = __rest(props, ["m", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "mt", "mr", "mb", "ml", "mx", "my", "marginX", "marginY"]);
    const marginProps = {
        m,
        margin,
        marginTop,
        marginRight,
        marginBottom,
        marginLeft,
        marginX,
        marginY,
        mt,
        mr,
        mb,
        ml,
        mx,
        my
    };
    removeUndefinedKeys(marginProps);
    return {
        marginProps,
        restProps
    };
};
export { extractClassNameProps, extractWidthProps, extractHeightProps, extractWrapperMarginProps };
